import { IInitialBrandUsersState } from 'interfaces/brandUsers.interface';

const initialBrandUsersState: IInitialBrandUsersState = {
  brandUsers: [],
  brandUsersSelected: null,
  isLoadingUsers: false,
  isLoadingAction: false,
  getBrandUsers: () => Promise.resolve(false),
  selectBrandUser: () => {},
  createBrandUser: () => Promise.resolve(false),
  updateBrandUser: () => Promise.resolve(false),
  deleteBrandUser: () => Promise.resolve(false),
};

export default initialBrandUsersState;
